<template>
  <div class="benefit-container flex-box">
    <div class="benefit-title">璞华易研PLM系统应用效益</div>
    <div class="benefit-description flex-box">
      <div>璞华易研PLM系统，强大的产品开发和实施团队，助力企业研发数智化，优化产品研发全流程管理、增强产品市场竞争力！</div>
    </div>
    <div class="benefit-data">
      <div
        class="benefit-item inline-flex-box"
        :class="{'mr-25': (index + 1) % 3, 'mb-25': index < 3}"
        v-for="(item, index) in benefitList"
        :key="index"
        @mouseenter="intoBlock(index)">
        <div class="left-context">
          <div class="top-num">
            <count-to
              :startVal='0'
              :endVal="item.value"
              :duration='2000'
              :decimals="item.decimals"
              ref="CountToPower" />
            <span class="percentage">%</span>
          </div>
          <div class="bottom-label">{{ item.label }}</div>
        </div>
        <div class="right-img">
          <img v-lazy="item.img" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
export default {
  components: {countTo},
  data() {
    return {
      benefitList: [
        {
          value: 35,
          decimals: 0,
          label: '研发成本下降',
          img: require('@/assets/images/xy1.png')
        },
        {
          value: 40,
          decimals: 0,
          label: '提升研发效率',
          img: require('@/assets/images/xy2.png')
        },
        {
          value: 50,
          decimals: 0,
          label: '变更处理周期下降',
          img: require('@/assets/images/xy3.png')
        },
        {
          value: 25,
          decimals: 0,
          label: '设计错误和返工下降',
          img: require('@/assets/images/xy4.png')
        },
        {
          value: 38,
          decimals: 0,
          label: '原材料种类下降',
          img: require('@/assets/images/xy5.png')
        },
        {
          value: 60,
          decimals: 0,
          label: '新产品上市周期缩短',
          img: require('@/assets/images/xy6.png')
        },
      ]
    }
  },
  methods: {
    intoBlock(index) {
      const value = this.benefitList[index].value;
      this.benefitList[index].value = 0;
      this.$nextTick(() => {
        this.benefitList[index].value = value;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.benefit-container {
  height: 79rem;
  background: linear-gradient(180deg, #66ACFF 0%, #3674FE 100%);
  padding: 8rem 26rem 9.1rem;
  flex-direction: column;
  align-items: center;

  .benefit-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .benefit-description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 2.4rem;
    flex-direction: column;
    align-items: center;
    margin-bottom: 6.6rem;
  }

  .benefit-data {
    width: 140rem;
    height: 46.5rem;

    .benefit-item {
      width: 45rem;
      height: 22rem;
      background: linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0.8) 100%);
      border: 0.2rem solid #FFFFFF;
      box-sizing: border-box;
      padding: 4rem 3.2rem 4rem 4.8rem;
      justify-content: space-between;

      .left-context {
        padding: 1.6rem 0;

        .top-num {
          font-size: 7.2rem;
          font-family: DINAlternate-Bold, DINAlternate;
          //font-family: Din;
          font-weight: bold;
          color: #3674FE;
          line-height: 7.2rem;

          .percentage {
            font-size: 4.8rem;
            font-family: Din;
            //font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #666A77;
            line-height: 7.2rem;
          }
        }

        .bottom-label {
          font-size: 2.4rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 2.4rem;
        }
      }

      .right-img {
        width: 14rem;
        height: 14rem;
        background-size: cover!important;
        background-repeat: no-repeat!important;
        img {
          width: 100%;
          height: 100%;
          z-index: -1;
        }
      }
    }

    .mr-25 {
      margin-right: 2.5rem;
    }

    .mb-25 {
      margin-bottom: 2.5rem;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .benefit-container {
    height: auto;
    padding: 4.8rem 1.6rem;

    .benefit-title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .benefit-description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 2.4rem;
      text-align: center;
    }
    .benefit-data {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.2rem;
      width: 100%;
      height: auto;
      .benefit-item {
        width: auto;
        min-width: 0;
        height: auto;
        margin: 0;
        padding: 1.6rem 1.2rem;
        overflow: visible;
        align-items: center;
        .left-context {
          padding: 0;
          min-width: 0;
          .top-num {
            font-size: 3.2rem;
            line-height: 3.6rem;
            .percentage {
              font-size: 2rem;
              line-height: 3.6rem;
            }
          }
          .bottom-label {
            font-size: 1.3rem;
            line-height: 1.8rem;
            margin-top: 0.4rem;
            white-space: normal;
            word-break: break-word;
          }
        }
        .right-img {
          width: 4.8rem;
          height: 4.8rem;
          flex-shrink: 0;
          margin-left: 0.4rem;
        }
      }
      .mr-25,
      .mb-25 {
        margin: 0;
      }
    }
  }
}
</style>
